var swiper7 = new Swiper(".cryoInfo", {
    slidesPerView: 3,
    spaceBetween: 30,
    loop: false,
    speed: 350,
    navigation: {
        nextEl: ".infocard-next",
        prevEl: ".infocard-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + "</span>";
        },
    },
    breakpoints: {
      280: {
        slidesPerView: 1.5,
        spaceBetween: 30,
      },
      720: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1500: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
});


//TEXT HOVER
  function applyDynamicTransforms() {
    const isDesktop = window.innerWidth > 990;

    const slides = document.querySelectorAll('.cryoHover');

    slides.forEach(slide => {
      const innerText = slide.querySelector('.inner-text');
      const content = slide.querySelector('.content');

      if (innerText && content) {
        if (isDesktop) {
          const height = innerText.offsetHeight;
          content.style.transform = `translateY(${height}px)`;
        } else {
          content.style.transform = 'translateY(0)';
        }
      }
    });
  }

  window.addEventListener('load', applyDynamicTransforms);
  window.addEventListener('resize', applyDynamicTransforms);

